import { useState } from "react";

import { fecha } from "../../shared/rto";
import {
  MOTIVO_SUGERIDO,
  declaradaGana,
  firma,
  hayDeclarada,
  sePuedeDeclarar,
} from "../../shared/rtoDeclarada";

/* La celda «Vence» de las dos tablas de RTO, que además se escribe.
 *
 * ── POR QUÉ ACÁ Y NO SÓLO EN LA FICHA ────────────────────────────────────
 *
 * La ficha ya deja cargar la fecha del título, y con eso solo esto no se
 * llenaría nunca: son **142 unidades activas** de la compra 2025/2026, y de a
 * una es abrir la ficha, esperar seis bloques, cargar, volver. Ciento cuarenta
 * y dos veces. Es exactamente lo que ya pasó con `lona` (679 de 679 sin
 * cargar) y con `tipo_servicio` (224 de 224): una columna que no se llena el
 * primer mes no se llena nunca, «sin dato» deja de ser un estado y pasa a ser
 * el único.
 *
 * Acá es tabular: se abre la solapa, se prende el lápiz, y se van tipeando las
 * fechas de los títulos que están en la mano.
 *
 * ── LO QUE NO PUEDE DECIR MAL ────────────────────────────────────────────
 *
 *   · **La declarada se MARCA en la celda** («· título»). Sin eso, una fecha
 *     que escribió una persona y una que contestó el CENT se leen igual en una
 *     columna de 658 filas, y no pesan lo mismo.
 *   · **El campo no se ofrece donde el CENT ya manda** salvo que haya una
 *     declarada que corregir. Un campo que se llena y no cambia nada visible
 *     es una llave que no abre nada.
 *   · **«No se pudo guardar» se dice, y el valor NO se pinta como guardado.**
 *     La fila se marca y el motivo queda a la vista: un campo que se revierte
 *     solo mientras la pantalla dice que anda es la falla que tuvo la pantalla
 *     de Documentos durante meses.
 */
const CeldaVence = ({ fila, editando, onGuardar }) => {
  const [error, setError] = useState(null);
  const [yendo, setYendo] = useState(false);

  const dominio = fila?.dominio;
  const puede = editando && !!dominio && sePuedeDeclarar(fila);

  if (!puede) {
    return (
      <>
        {fecha(fila?.vence)}
        {declaradaGana(fila) && (
          <em className="tk-item-meta" title={firma(fila) || undefined}>
            {" "}
            · título
          </em>
        )}
      </>
    );
  }

  /* Se guarda al SALIR del campo, no en cada tecla: un `<input type=date>`
   * dispara `change` con años a medio escribir, y eso serían tres escrituras
   * por fecha —dos de ellas con una fecha que nadie quiso guardar, firmadas
   * igual—. */
  const salir = async (ev) => {
    const v = ev.target.value;
    if (!v || v === (fila.declarada || "")) return;
    setError(null);
    setYendo(true);
    try {
      /* El motivo va el sugerido y no vacío: esto se carga en tanda y pedir
       * que además se escriba el porqué en cada fila es lo que hace que se
       * cargue en otro momento, o sea nunca. Se corrige de a una desde la
       * ficha, que es donde hay lugar para escribirlo. */
      await onGuardar(dominio, v, fila.declarada_motivo || MOTIVO_SUGERIDO);
    } catch (e) {
      setError(e.message || "No se pudo guardar");
    } finally {
      setYendo(false);
    }
  };

  return (
    <>
      <input
        type="date"
        className={"tu-fecha" + (error ? " activo" : "")}
        defaultValue={fila.declarada || ""}
        disabled={yendo}
        onBlur={salir}
        aria-label={`Vencimiento del título de ${dominio}`}
      />
      {/* Lo que ya contestó el CENT queda a la vista al lado del campo, así
          quien está corrigiendo una declarada vieja ve contra qué compite. */}
      {fila.fuente === "cent" && (
        <em className="tk-item-meta"> · CENT {fecha(fila.vence)}</em>
      )}
      {!hayDeclarada(fila) && fila.fuente !== "cent" && (
        <em className="tk-item-meta"> · sin cargar</em>
      )}
      {error && <em className="tk-item-meta rto-ojo"> · {error}</em>}
    </>
  );
};

export default CeldaVence;
